// toErrorMessage extracts a human-readable message from a thrown value, falling
// back to a generic retry prompt for non-Error throwables or empty messages.
// Used by the receiving action screens to surface backend {message} bodies
// (e.g. the 409 "companion is not connected") that the fetch wrapper rethrows.
export function toErrorMessage(err: unknown): string {
  return err instanceof Error && err.message
    ? err.message
    : 'Something went wrong — please try again.';
}
